import styled from 'styled-components';
import { breakpoints } from '../../breakpoints';

export const App = styled.div`
  display: flex;
  position: relative ;
  flex-direction: column;
  width: 100vw ;
  height: 92vh;
  margin-top:50px ;
  background-color: #2b2b2b;
  overflow: hidden ; 
  font-size: clamp(11px, 3vw, 16px);
  align-items: center ;

  button{
    cursor: pointer;
    border:none;
  }

  .fundoBloque{
  display: ${props => props.fundoBloque ? 'flex' : 'none'} ;
  width: 100vw;
  height: 90vh; 
  background-color: rgba(20, 20, 20, 0.8);
  position: fixed ;
  z-index: 1 ;
  };
`

export const body = styled.div`
display: flex;
position: relative ;
flex-direction: column ; 
align-items: center ;
background-color: black;
width: 100vw ;
max-width: 500px ;
height: 90vh ;
padding: 0 10px ;

`
// -----------------------------
export const VistoriaModal = styled.div`
display: flex ;
flex-direction: column ;
margin-top: 10px ;
`
//-----------------------------------------------
export const Container = styled.div`
display: flex;
flex-direction:column ;
width:95vw ;
width:500px ;

.listaFlexCol{
  display: flex ;
  flex:1 ;
  flex-direction: column ;
  text-transform:capitalize;
  color: white ;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

input{
color: white ;
border:none;
background:none;
outline:0;
background-color: #353535 ;
}

input, select{
  height:30px ;
}

select{
  display:flex;
  border-radius:3px;
  border:none;
  outline:0;
}

`

// ------------------------------------------
export const div3 = styled.div` 
display:flex;
flex-direction: column ;
color: #00D594;
align-items: center ;

.spanBranco{
  margin:0px ;
  color: white ;
}

.novoCad{
  color: black ;
  background-color: white ;
  padding: 1px 3px ;
  cursor: pointer;
}

.maiusculo{
  text-transform:capitalize
}
.uppercase{
  text-transform:uppercase
};

.intemSelect{
  display: flex ;
  align-items: center ;
  height: 30px ;
  background-color: #30353F;
  color: white ;
  min-height: 25px ;
  cursor: pointer;
  padding-left: 5px ;
  text-transform:capitalize;
};
.intem{
  display: flex ;
  color: #d8e5ffff;
}

.EditarSelect{
  display: flex ;
  flex:1 ;
  flex-direction: column ;
  margin: 0 5px ;
}
`

// ------------------------------------
export const box1 = styled.div` 
display:flex;
flex-wrap: wrap ;
width:95vw ;
max-width:500px ;

border-bottom:1px solid #3881ff;
gap: 5px;
position: relative ;

input{
  text-transform:capitalize;
}

@media ${breakpoints.sm} {
  flex-direction: column ;
}

button{
  display: flex ;
  background-color: white ;
  align-items: center ;
  justify-content: center ;
  color: black ;
  height: 18px ;
  margin: 2px 0;
  border: none ;
  border-radius: 3px ;
  cursor: pointer;

  &:hover{
    background-color:#00ff9d;
    }
}

`

//-----------------------------
export const divButton = styled.div` 
display: flex ;
justify-content: center ;
margin-top: 10px ;

button{
  background-color:#00D594;
  min-width: 80px;
  height:20px;
  margin:3px;
  justify-content:center;
  border:none;
  border-radius:3px;
  color:${props => props.editModal ? 'white' : 'black'};
  cursor: pointer;

}
`
// ------------------------------
export const Modal = styled.div`
display: flex ;
overflow:auto ;
flex-direction: column ;

button{
  background-color:#00D594;
  min-width: 110px;
  min-height:34px;
  margin:3px;
  justify-content:center;
  border:none;
  border-radius:8px;
  color:${props => props.editModal ? 'white' : 'black'};
  cursor: pointer;
  font-weight: 600;
  transition: all .2s ease;

  &:hover{
    filter: brightness(1.05);
    transform: translateY(-1px);
  }

}
`


// ----------------------------------


